var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',{staticClass:"dataweekLocal"},[_c('div',{domProps:{"innerHTML":_vm._s(_vm.dateFormat(_vm.newDate))}})])
}
var staticRenderFns = []

export { render, staticRenderFns }